import type {
  MonitoringEnrollmentPresentation,
  MonitoringEnrollmentView,
  MonitoringTargetRecord,
} from '@/api/monitoring';

const ELIGIBLE_LIFECYCLES = new Set(['pending', 'active', 'suspended']);

export function isMonitoringEnrollmentTargetEligible(
  target: Pick<MonitoringTargetRecord, 'type' | 'lifecycle'>,
): boolean {
  return target.type === 'linux'
    && ELIGIBLE_LIFECYCLES.has(target.lifecycle)
    && target.lifecycle !== 'decommissioned';
}

const PRESENTATION_COPY: Record<MonitoringEnrollmentPresentation, string> = {
  awaiting_approval: 'Ожидается подтверждение регистрации',
  awaiting_agent: 'Подтверждено — ожидается ответ Linux-агента',
  binding: 'Станция зарегистрирована — создаётся привязка к target',
  complete: 'Станция привязана к monitoring target',
  cancelled: 'Регистрация отменена',
  expired: 'Срок регистрации истёк',
  manual_recovery_required: 'Требуется безопасное ручное восстановление',
  temporarily_unavailable: 'Сервис регистрации временно недоступен',
};

export function monitoringEnrollmentPresentation(view?: MonitoringEnrollmentView | null): string {
  if (!view) return 'Активной регистрации пока нет';
  return PRESENTATION_COPY[view.presentation];
}

export function monitoringEnrollmentProblemMessage(error: unknown): string {
  const response = (error as { response?: { data?: unknown } } | null)?.response;
  const data = response?.data;
  if (typeof data === 'object' && data !== null && !Array.isArray(data)) {
    const record = data as Record<string, unknown>;
    const code = typeof record.code === 'string' ? record.code : '';
    const messages: Record<string, string> = {
      enrollment_version_conflict: 'Состояние изменилось. Обновите статус и повторите действие.',
      enrollment_replay_conflict: 'Этот идентификатор операции уже использован с другими данными.',
      enrollment_context_mismatch: 'QR, клиент или выбранный target больше не совпадают.',
      enrollment_recovery_required: 'Автоматическое продолжение небезопасно. Нужна ручная проверка.',
      enrollment_dependency_unavailable: 'Сервис регистрации временно недоступен.',
      enrollment_not_found: 'Регистрация не найдена или больше недоступна.',
    };
    if (messages[code]) return messages[code];
    if (typeof record.detail === 'string' && record.detail.length <= 240) return record.detail;
    if (typeof record.title === 'string' && record.title.length <= 160) return record.title;
  }
  return error instanceof Error ? error.message : 'Не удалось выполнить операцию';
}
